const spacing = {
  spacing: 4,
};

export default spacing;
